import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Immutable, { Map } from 'immutable';

import MyTasks from './MyTasks';

import RightPanelColumn from './RightPanelColumn';

import '../../../styles/Project.css';
import IssuesBreakdownContainer from './IssuesBreakdown/';

class Project extends Component {
  static propTypes = {
    project: PropTypes.object,
    user: PropTypes.instanceOf(Map),
  };

  constructor(props) {
    super(props);

    const apolloData =
      props.data.userDashboardLayout &&
      props.data.userDashboardLayout.dashboard_preferences
        ? Map(props.data.userDashboardLayout.dashboard_preferences)
        : null;

    const userPreferences =
      apolloData ||
      Map({
        top: 'UserScoreboard',
        middle: 'UserRanking',
        bottom: 'ActivityFeed',
      });

    const demoValue = props.project.getIn(['props', 'Demo', '_value']);
    const displayUserId = demoValue && demoValue.getIn(['displayUserId']);
    const selectedUserId = displayUserId || props.user.get('id');

    this.state = {
      selectedUserId,
      currentElement: Map(),
      panelComponents: userPreferences,
    };
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.currentPropId !== nextProps.currentProjectId) {
      this.setState({
        currentElement: Map(),
      });
    }
  };

  updateSelectedUser = userId => {
    this.setState({ selectedUserId: userId });
  };

  setCurrentElement = currentElement => {
    this.setState({
      currentElement: Immutable.fromJS(currentElement) || Map(),
    });
  };

  setPanel = (position, item) => {
    const {
      updateUserDashboardPreferencesMutation,
      user,
      currentProjectId,
    } = this.props;
    const { panelComponents } = this.state;
    const newPanelComponent = panelComponents.set(position, item);

    updateUserDashboardPreferencesMutation(
      user.get('id'),
      currentProjectId,
      'Dashboard',
      newPanelComponent,
    );

    this.setState({
      panelComponents: newPanelComponent,
    });
  };

  render() {
    const {
      project,
      user,
      users,
      projectUsers,
      enableDashboardLayout,
      product,
    } = this.props;
    const { selectedUserId, currentElement, panelComponents } = this.state;

    return (
      <div className="dashboard-flex-wrapper">
        <div className="dashboard-flex-left-column" style={{ marginRight: 20 }}>
          {
            product && product !== 'issues' ? <MyTasks
              setCurrentElement={this.setCurrentElement}
              projectId={project.get('id')}
              projectUsers={projectUsers}
              user={user}
              updateSelectedUser={this.updateSelectedUser}
              userId={selectedUserId}
              selectedUser={users.get(selectedUserId)}
            /> : <IssuesBreakdownContainer
              projectId={project.get('id')}
              setCurrentElement={this.setCurrentElement}
            />
          }
        </div>
        <RightPanelColumn
          currentElement={currentElement}
          enableDashboardLayout={enableDashboardLayout}
          panelComponents={panelComponents}
          setPanel={this.setPanel}
          setCurrentElement={this.setCurrentElement}
          product={product}
          {...this.props}
        />
      </div>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/Project.js